import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { updateAlertStatus } from '../alert.api';
import { QueryKey } from '@/api/common/types/query-key.enum';
import logger from '@/services/logger';
import type { Alert } from '../types/alert';

export const useUpdateAlertStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAlertStatus,
    retry: 3,
    onMutate: async payload => {
      await queryClient.cancelQueries({ queryKey: [QueryKey.GetAlerts] });
      const oldAlerts = queryClient.getQueryData<Alert[]>([QueryKey.GetAlerts]);
      queryClient.setQueryData<Alert[]>([QueryKey.GetAlerts], oldData => {
        if (!oldData) return [];
        return oldData.map(alert => {
          if (payload.alertId === alert.id) {
            return {
              ...alert,
              readAt: alert.readAt ?? new Date().toISOString(),
              data: { ...alert.data, status: payload.status },
            };
          }
          return alert;
        });
      });
      return { oldAlerts };
    },
    onError: (err, _, context) => {
      logger.error({
        message: '[useReadAlerts] - Failed to read alerts after retries',
        data: {},
        error: err as Error,
      });
      if (context?.oldAlerts) queryClient.setQueryData([QueryKey.GetAlerts], context.oldAlerts);
    },
  });
};
